import Vue from "vue";
import ENGLISH_PHRASE from "../constants/multi-languages/en";

Vue.mixin({
    methods: {
        /*
        Example: obj: {key1: {key2: {key3: value}}}
        key: "key1.key2.key3"
        Return value
        */
        getValueOfNestedObject(obj, multiLevelKey) {
            const keys = multiLevelKey.split('.');
            let currentObj = obj;
            for (let index = 0; index < keys.length; index++) {
                const key = keys[index];
                if (currentObj[key]) {
                    if (index === keys.length - 1) {
                        return currentObj[key]
                    } else {
                        currentObj = currentObj[key];
                        if (typeof currentObj !== 'object') {
                            return "";
                        }
                    }
                } else {
                    return "";
                }
            }
            return "";
        },
        getLabelByKeys(key, ...args) {
            if (!key) {
                return '';
            }
            let label = this.getValueOfNestedObject(this.$store.getters.multiLanguageValues, key);
            if (!label) {
                // If phrase is not defined for the language, use phrase in English
                label = this.getValueOfNestedObject(ENGLISH_PHRASE, key);
            }
            if (args && args.length) {
                return this.formatContent(label, ...args);
            } else {
                return label;
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/mixins/multi-language-handling.js